module.exports = __webpack_public_path__ + "static/media/nothing.78fd7a96.svg";